import type { UpdateStateInput } from '@idc-forms/schemas'
import { axiosPrivate } from '@/shared/api/axios'
import { buildListQueryString } from '@/shared/api/build-list-query-string'
import { API } from '@/shared/constants/api'
import type { PaginatedStates, StateAdminRow, StatesAdminParams } from '../models/state-admin'

export async function getStatesAdmin(params: StatesAdminParams): Promise<PaginatedStates> {
  const qs = buildListQueryString(params)
  const { data } = await axiosPrivate.get<PaginatedStates>(
    `${API.states.root}${qs ? `?${qs}` : ''}`
  )
  return data
}

/**
 * Mutaciones del panel (toggle activo, borrado). El alta y la edición completa
 * viven en la página create-update-state (editor de requisitos incluido).
 * El payload es el MISMO schema Zod que valida el backend.
 */
export async function updateState(id: string, payload: UpdateStateInput): Promise<StateAdminRow> {
  const { data } = await axiosPrivate.patch<StateAdminRow>(API.states.byId(id), payload)
  return data
}

export async function deleteState(id: string) {
  const { data } = await axiosPrivate.delete(API.states.byId(id))
  return data
}
